module.exports = __webpack_public_path__ + "svg/flags/United States Minor Outlying Islands.svg";